



































// 3rd party libs
import {
    mapActions,
} from 'vuex';

// Local modules
import localStoreTypes from '@webapp/store/types.js';

export default {
    name: 'subcategory-filter-toggle',
    methods: {
        ...mapActions({
            setModal: localStoreTypes.SET_MODAL,
        }),

        openFilters() {
            this.setModal({
                componentToLoad: 'modules/rewards/components/fanshop/partner/subcategory-filter-sheet',
                containerClass: 'container--no-radius container--align-right container--full-height container--no-close-icon',
                isVisible: true,
                maxWidth: '330px',
                isClosable: true,
                slideFromRight: true,
            });
        },
    },
};
